import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {
  VAPID_KEY,
  FIREBASE_apiKey,
  FIREBASE_authDomain,
  FIREBASE_databaseURL,
  FIREBASE_projectId,
  FIREBASE_storageBucket,
  FIREBASE_messagingSenderId,
  REACT_APP_FIREBASE_appId,
  FIREBASE_measurementId,
} from "AppConfig";
import { postInitNotificationAPI } from "core/http/service/notification";
const firebaseConfig = {
  apiKey: FIREBASE_apiKey,
  authDomain: FIREBASE_authDomain,
  databaseURL: FIREBASE_databaseURL,
  projectId: FIREBASE_projectId,
  storageBucket: FIREBASE_storageBucket,
  messagingSenderId: FIREBASE_messagingSenderId,
  appId: REACT_APP_FIREBASE_appId,
  measurementId: FIREBASE_measurementId,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const requestForToken = async (
  employeeCode,
  uuid,
  callback
): Promise<string | void> => {
  const requestToken = async () => {
    try {
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
      });
      const deviceId = localStorage.getItem("deviceId");
      const body = {
        name: deviceId,
        token,
      };

      if (!deviceId || !employeeCode) {
        return;
      }

      if (deviceId && !deviceId.includes(employeeCode)) {
        const newDeviceId = `${employeeCode}_${uuid}-WEBSITE`;
        localStorage.setItem("deviceId", newDeviceId);
        body.name = newDeviceId;
      }
      await postInitNotificationAPI(body);
      if (callback) {
        callback();
      }
    } catch (error: any) {}
  };
  try {
    let permission = await Notification.requestPermission();
    if (permission === "granted") {
      await requestToken();
    } else {
      permission = await Notification.requestPermission();
      if (permission === "granted") {
        await requestToken();
      }
    }
  } catch (error) {}
};

export { messaging, getToken, onMessage, requestForToken };
